import Vue from 'vue'
let debug = Vue.config.devtools;
export default {
    // 必须/结尾
    aesKey: 'xdd', // AES加密密钥
    // 部署时也是前后端分离，两个工程名不一样，接口走xyfx-back关键字，页面走back
    projectName: debug ? 'xdd-website/' : 'xdd-website/' //
}